import React, { useEffect } from 'react';
import { Body, FormCadastro, PageHeader, Field, GroupField, Input, Spin, View } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getLog } from '@ducks/conectoresLogs';

import App from '@app';

export default function Detalhes() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id, idConfiguracao } = useParams();

  const log = useSelector(({ conectoresLogs }) => conectoresLogs.get('log'));
  const successLog = useSelector(({ conectoresLogs }) => conectoresLogs.get('successLog'));
  const loadingLog = useSelector(({ conectoresLogs }) => conectoresLogs.get('loadingLog'));

  const handleSearch = () => {
    return dispatch(getLog(idConfiguracao, id));
  };

  useEffect(() => {
    if (log) {
      form.setFieldsValue(log);
    }
  }, [successLog]);

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <App>
      <Body>
        <PageHeader title="Log" onBack={() => history.goBack()}>
          <FormCadastro form={form}>
            {loadingLog ? (
              <Spin />
            ) : (
              <View>
                <GroupField>
                  <Field label="Tipo do log" name="tp">
                    <Input disabled />
                  </Field>
                  <Field label="Data do log" name="dt">
                    <Input disabled />
                  </Field>
                  <Field label="Versão" name="versao">
                    <Input disabled />
                  </Field>
                </GroupField>
                <GroupField>
                  <Field label="Descrição" name="ds">
                    <Input.TextArea rows={15} disabled />
                  </Field>
                </GroupField>
              </View>
            )}
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
